import { CustomAction } from '../../../generalTypes';
import { SET_DRAFT_CEILING_HEIGHT } from '../../actionConstants';

export const actionSetDraftCeilingHeight = (
  value: number,
  meta = {}
): CustomAction<{ value: number }> => ({
  type: SET_DRAFT_CEILING_HEIGHT,
  payload: {
    value,
  },
  meta,
});
